<template>
  <div>
    <p class="my-5">
      Video applications are becoming more common. Once you have recorded your video, you can select
      it and upload it below.
    </p>

    <div v-if="uploadedVideoApplication !== false">
      <video-player ref="player" class="media-video-player" :options="videoOptions" v-once />
      <button
        class="my-5 btn btn-secondary danger btn-size-medium includedIcon"
        @click="removeUploadedApplication"
      >
        <trash-2-icon /> Remove Video Application
      </button>
    </div>
    <div v-else>
      <p>Select video application</p>
      <div class="flex flex-col mt-5 sm:flex-row">
        <div class="sm:mr-2">
          <input
            type="file"
            id="application-video-file"
            ref="file"
            v-on:change="handleFileUpload()"
            style="display: none"
          />
          <button class="w-full btn btn-secondary btn-size-medium" @click="$refs.file.click()">
            Select File
          </button>
        </div>
        <div>
          <button
            class="w-full btn btn-secondary btn-size-medium includedIcon"
            @click="submitFile()"
          >
            <upload-icon /> Upload Video Application
          </button>
        </div>
      </div>
      <vs-progress
        indeterminate
        color="primary"
        v-if="uploadingApplication"
        class="sm:w-1/4"
      ></vs-progress>
      <p class="my-3">
        <small>{{ file.name }}</small>
      </p>
    </div>
  </div>
</template>

<script>
import store from '@/store/store';
import { videoPlayer } from 'vue-video-player';
import 'video.js/dist/video-js.css';
import theApi from '@/mixins/theApi';
import { UploadIcon, Trash2Icon } from 'vue-feather-icons';

export default {
  computed: {
    prework() {
      return store.getters['authStudent/prework'];
    },
  },
  components: { videoPlayer, UploadIcon, Trash2Icon },
  data() {
    return {
      file: '',
      uploadedVideoApplication: false,
      uploadingApplication: false,

      videoOptions: {
        height: '360',
        fluid: true,
        autoplay: false,
        muted: true,
        language: 'en',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: { type: 'video/mp4', src: 'http://vjs.zencdn.net/v/oceans.mp4' },
      },
    };
  },
  methods: {
    async removeUploadedApplication() {
      theApi.methods.makeCall(false, 'apply/video/remove', 'get').then((data) => {
        this.file = '';
        if (data.status == 'OK') {
          this.uploadedVideoApplication = false;
          this.videoOptions.sources.src = false;

          const pw_data = {
            status_section: 'section_apply',
            section: 'application_video',
            data: null,
            application_type: null,
          };
          store.dispatch('authStudent/completePreworkSection', pw_data);
        }
      });
      this.uploadingApplication = false;
    },
    async submitFile() {
      this.uploadingApplication = true;
      let formData = new FormData();
      formData.append('file', this.file);

      theApi.methods.makeCall(false, 'apply/video/upload', 'post', formData, false, true).then(
        (data) => {
          this.file = '';
          if (data.status == 'OK') {
            this.uploadedVideoApplication = data.url;
            this.videoOptions.sources.src = data.url;

            const pw_data = {
              status_section: 'section_apply',
              section: 'application_video',
              data: data.url,
              application_type: 2,
            };
            store.dispatch('authStudent/completePreworkSection', pw_data);
          }
        },
        () => {
          this.uploadingApplication = false;
        },
      );
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
  },
  mounted() {
    if (
      this.prework.application_video &&
      this.prework.application_video != '' &&
      this.prework.application_video != null
    ) {
      this.uploadedVideoApplication = this.prework.application_video;
      this.videoOptions.sources.src = this.prework.application_video;
    }
  },
};
</script>
